import { all } from "redux-saga/effects";
import { watchGameActionsSaga } from "./sagas";

export default function* rootSaga() {
  yield all([watchGameActionsSaga()]);
}
